// extracted by mini-css-extract-plugin
export default {"submenuItemList":"SubmenuItemList_submenuItemList__88kKF","submenuItem":"SubmenuItemList_submenuItem__EOZh3"};